import type { RealtimeChannel } from "ably";
import { PeerConnectionError } from "@/hooks/usePeerConnectionErrors";
import { useStore } from "@/store";
import { confirmSend as confirmGenericSend } from "../../core";
import { visionAblyChannelName } from "../messaging";
import type { ConnectionStatus } from "./useVisionPresence";

type ConfirmSendOptions = {
	timeoutMs?: number;
	connectionStatus?: ConnectionStatus;
	channel?: RealtimeChannel | null;
};

export function confirmSend(message: { name: string; data: unknown }, options: ConfirmSendOptions = {}) {
	const sessionId = useStore.getState().sessionId;
	const requestedScreenColor =
		typeof message.data === "object" && message.data !== null && "screenColor" in message.data
			? (message.data as { screenColor?: string }).screenColor
			: undefined;

	return confirmGenericSend(message, {
		timeoutMs: options.timeoutMs,
		channel: options.channel,
		channelName: visionAblyChannelName(sessionId),
		connectionGuard: options.connectionStatus
			? {
					isConnected: options.connectionStatus.isEvaluatedDeviceConnected,
					isReady: options.connectionStatus.isInitialCheckComplete,
				}
			: undefined,
		createConnectionError: () => new PeerConnectionError(),
		createTimeoutError: () => new PeerConnectionError(),
		responseName: "capture-flow-ack",
		isExpectedResponse: (response) => {
			const responseData = response.data as { isScreenColorApplied?: boolean; screenColor?: string } | undefined;
			return responseData?.isScreenColorApplied === true && responseData.screenColor === requestedScreenColor;
		},
	});
}
